import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size?: 'default' | 'narrow' | 'wide';
}

export default function Container({
  children,
  size = 'default',
  className,
  ...rest
}: ContainerProps) {
  const max =
    size === 'narrow' ? 'max-w-3xl' : size === 'wide' ? 'max-w-[1360px]' : 'max-w-container';
  return (
    <div className={cn('mx-auto w-full px-6 md:px-10', max, className)} {...rest}>
      {children}
    </div>
  );
}
